/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import DropDownList from 'saur_ui_library/src/Molecules/DropDownList/DropDownList';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import styled, { createGlobalStyle } from 'styled-components';
import Error from '../../components/common/ErrorMessage';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import {
  DurationByHour,
  beforeSubmit,
  getRainParam,
} from '../../utils/helpers/view/contractParameterHelper';
import { loaderDataComponent } from '../../utils/helper';

declare type PluieProps = {
  contractId: string;
};

type formType = {
  id: null | any;
  pjMinus1: null | any;
  pjMinus1PjMinus2: null | any;
  pjMinus1High: null | any;
};

const RainParameter = ({ contractId }: PluieProps) => {
  // déclaration des variables
  const [error, setError] = useState(false);
  const [pluieList, setPluieList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [, setErrorMessage] = useState(
    "une erreur s'est produite. Veuillez réessayer"
  );
  const [, setTitle] = useState('');
  //Form fields on initialization with getParam value
  const [form, setForm] = React.useState<formType>({
    id: pluieList.id,
    pjMinus1: pluieList.pjMinus1,
    pjMinus1PjMinus2: pluieList.pjMinus1PjMinus2,
    pjMinus1High: pluieList.pjMinus1High,
  });
  //Form fields validation
  const [validation, setValidation] = React.useState<{
    pjMinus1PjMinus2: null | any;
    pjMinus1High: null | any;
  }>({
    pjMinus1PjMinus2: null,
    pjMinus1High: null,
  });

  const validate = () => {
    setValidation(() => ({
      pjMinus1PjMinus2:
        form.pjMinus1PjMinus2 >= form.pjMinus1
          ? null
          : 'Attention! Pj-2 + Pj-1 doit être supérieur ou égal à Pj-1',
      pjMinus1High:
        form.pjMinus1High > form.pjMinus1
          ? null
          : 'Attention! Pj-1HAUT doit être strictement supérieur à Pj-1',
    }));
  };

  const arrayHour = DurationByHour().map((c, index) => {
    return {
      id: index,
      label: c.name,
      value: c.id,
      automatedTestId: 'dropdown-date' + index,
    };
  });

  const toast = useRef<any>(null);

  //Use effects
  useEffect(() => {
    getRainParam(
      setLoading,
      contractId,
      setPluieList,
      setForm,
      setError,
      setTitle,
      setErrorMessage
    );
  }, [contractId]);

  useEffect(() => {
    validate();
  }, [form]);

  //fonctions de validations
  function handleOnSubmit() {
    validate();
    beforeSubmit(validation, setLoading, form, contractId, toast);
  }

  return (
    <Container
      automatedTestId='rain-global-container'
      className='rain-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Form onSubmit={handleOnSubmit}>
        <Card className='rainContainer'>
          <Container className='rainContent'>
            <Container className='tempsSec'>
              <Word
                variant='p'
                textStyle='title'
                value='Définition du « Temps sec »'
                className='temps-sec-title'
              />
              <Container className='blueline'></Container>
              <Container className='pj-1'>
                <Word
                  variant='p'
                  textStyle='normalBold'
                  value='PJ-1'
                  className='pj-1-title'
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='Inférieure à'
                  className='pj-1-comparatif'
                />
                <InputNumber
                  className='rain-input'
                  id='input-pj-1'
                  value={form.pjMinus1}
                  onValueChange={(e: any) => {
                    setForm((oldValues) => {
                      return { ...oldValues, pjMinus1: e.value };
                    });
                  }}
                  mode='decimal'
                  minFractionDigits={1}
                  min={0}
                  max={5}
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='mm'
                  className='pj-1-unit'
                />
              </Container>
              <Container className='blueline'></Container>
              <Container className='pj-2'>
                <Word
                  variant='p'
                  textStyle='normalBold'
                  value='PJ - 2 + PJ - 1'
                  className='pj-2-title'
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='Inférieure à'
                  className='pj-2-comparatif'
                />
                <InputNumber
                  className='rain-input'
                  id='input-pj-2'
                  value={form.pjMinus1PjMinus2}
                  onValueChange={(e: any) => {
                    setForm((oldValues) => {
                      return { ...oldValues, pjMinus1PjMinus2: e.value };
                    });
                  }}
                  mode='decimal'
                  minFractionDigits={1}
                  min={0}
                  max={10}
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='mm'
                  className='pj-2-unit'
                />
              </Container>
              <Container className='formLineError'>
                <Word
                  className='error'
                  textStyle='normalReg'
                  variant='span'
                  value={validation.pjMinus1PjMinus2}
                />
              </Container>
              <Container className='blueline'></Container>
            </Container>
            <Container className='fortePluie'>
              <Word
                variant='p'
                textStyle='title'
                value='Définition de « Forte pluie »'
                className='forte-pluie-title'
              />
              <Container className='blueline'></Container>
              <Container className='pj-haut'>
                <Word
                  variant='p'
                  textStyle='normalBold'
                  value='PJ - 1  HAUT'
                  className='pj-h-title'
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='Supérieure ou égale à'
                  className='pj-h-comparatif'
                />
                <InputNumber
                  className='rain-input'
                  id='input-pj-h'
                  value={form.pjMinus1High}
                  onValueChange={(e: any) => {
                    setForm((oldValues) => {
                      return { ...oldValues, pjMinus1High: e.value };
                    });
                  }}
                  mode='decimal'
                  minFractionDigits={1}
                  min={10}
                  max={999}
                />
                <Word
                  variant='p'
                  textStyle='normalReg'
                  value='mm'
                  className='pj-h-unit'
                />
              </Container>
              <Container className='formLineError'>
                <Word
                  className='error'
                  textStyle='normalReg'
                  variant='span'
                  value={validation.pjMinus1High}
                />
              </Container>
              <Container className='blueline'></Container>
            </Container>
          </Container>
        </Card>
        <Container className='rainButton'>
          {loaderDataComponent(loading, `width: 34px;
              height: 34px;
              border: 5px solid #FFF;
              border-bottom-color: #243977;
              border-radius: 50%;
              position: relative;
              bottom: 2vh;
              display: inline-block;
              box-sizing: border-box;
              animation: rotation 1s linear infinite;`)}
          {loading === false && <StyledSectionButton>
            <Button className='param-btn' mode='plain'>
              <Word
                variant='span'
                textStyle='normalBold'
                value='Enregistrer les modifications'
              />
            </Button>
          </StyledSectionButton>}
        </Container>
      </Form>
      {error ? <Error IsVisible={error}></Error> : null}
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  align-self: center;
`;
const Styles = createGlobalStyle`
.rain-global-container.sds-reset-style{
  .loaderRainParameter {
    width: 34px;
    height: 34px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 
  .pi{
    font-family: 'primeicons';    
  }
  .blueline{
    border: 0.5px solid #008BD2;
    background-color:  #008BD2;
    width: 70%;
    align-self: center;
  }
  .formLineError{
    text-align: center;
    .error{
          color:red
        }
  }
  input.p-inputtext.p-component.p-inputnumber-input{
    background-color: #FFFFFF;
    border: 1px solid #CCE8F6;
    border-radius: 5px;
    width: 121px;
    height: 43px;
    text-align: center;
  }
  .rainContainer{
    margin-left: auto;
    margin-right: auto;
    width: 80rem;
    margin-bottom: 30px;
    position: relative;
    overflow: visible;
    margin-top: 20px;
    .rainContent{
      .tempsSec {
       margin-bottom:50px;        
        .temps-sec-title{
          align-self: center;
          margin-bottom:40px;
        }
        .pj-1{
          flex-direction: row;
          width: 70%;
          align-self: center;
          justify-content: space-between;
          margin-bottom: 1.5%;
          margin-top: 1.5%;
          .pj-1-unit,.pj-1-title,.pj-1-comparatif{
            align-self: center;
          }
          #input-pj-1{
            margin-left: 77px;
          }
          .pj-1-comparatif{
            margin-left: 40px;
          }
        }
        .pj-2{
          flex-direction: row;
          justify-content: space-between;
          width: 70%;
          align-self: center;
          margin-bottom: 1.5%;
          margin-top: 1.5%;
          .pj-2-unit,.pj-h-title,.pj-2-comparatif{
            align-self: center;
          }
          #input-pj-2{
            margin-left: 30px;
          }
          .pj-2-comparatif{
            margin-right: 50px;
          }
          
        }
        
      }
      .fortePluie{
       margin-bottom:50px;

        .forte-pluie-title{
          margin-bottom:40px;
          align-self: center;
        }
        .pj-haut{
          flex-direction: row;
          justify-content: space-between;  
          width: 70%;
          align-self: center;
          margin-bottom: 1.5%;
          margin-top: 1.5%;
          .pj-h-unit,.pj-h-title,.pj-h-comparatif{
            align-self: center;
          }
          #input-pj-h{
            margin-left: 57px;
          }
        }
      }
      .pluvParam{
        .pluv-title{
          align-self: center;
          margin-bottom:50px;
        }
        .pluv-List{
          width: 70%;
          align-self: center;
          display: flex;
          flex-direction: row; 
          justify-content: space-between;
          margin-bottom: 1.5%;
          margin-top: 1.5%;
          .pluv-text{
            align-self: center;
            font-size: 14px;
          }
          .dropDownList{
            width:50%;
            position: relative;
            .dropdown-list-item {
              padding: 0px;
            }
          }
        }
        .pluv-List > * {
          flex: 1 0 auto;
        }
        .sds-word.normalReg {
          font-size: 14px;
          margin-left: 15px;
           }
      }
    }
  }
}
`;

export default RainParameter;
